import hoverintent from 'hoverintent';

export default class HoverIntent {
  constructor(el) {
    this.el = el;
    const items = el.querySelectorAll('[data-hover-trigger]');
    const hoverIntentOpts = {
      sensitivity: 50,
      interval: 75,
      timeout: 150,
    };

    if ('ontouchstart' in document.documentElement) {
      console.log('')
    } else {
      items.forEach(function (elem) {
        hoverintent(
          elem,
          function () {
            let menuItems = elem.querySelectorAll('.g-nav__subItems > ul > li');
            menuItems = Array.from(menuItems);
            if (menuItems.length) {
              if (menuItems.every(item => item.classList.contains('hidden'))) {
                return;
              }
            }
            elem.classList.add('is-active');

            elem.addEventListener(
              'mouseover',
              function (event) {
                if (event.target.classList.contains('row')) {
                  elem.classList.remove('is-active');
                }
              },
              false
            );
          },
          function () {
            elem.classList.remove('is-active');
          }
        ).options(hoverIntentOpts);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/HoverIntent.js